/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useCallback } from "react";

import { BsFillPinMapFill } from "react-icons/bs";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useOlMap } from "../../../../../shared/hooks/useOlMap";
import { drawPolygon } from "../../../../../shared/utils/ol.utils";
import { showToast } from "../../../../global/toast";
import { ICemeteryGeom } from "../../../../../shared/interfaces/ICemetery";

interface PropertyActionsProps {
    lote: Partial<ICemeteryGeom>;
    doAfterClick?(): void;
    iconsSize?: number;
}

export const SearchFormActionLote: React.FC<PropertyActionsProps> = ({
    lote,
    doAfterClick,
    iconsSize = 18,
}) => {
    const { map } = useOlMap();

    const drawPropertyGeom = useCallback(async () => {
        if (!map) return;

        if (!lote.geom) {
            showToast({ type: "warn", message: "Lote não encontrado" });

            return;
        }

        drawPolygon({
            coordinates: lote.geom,
            map,
            padding: [180, 180, 180, 180],
        });

        if (doAfterClick) {
            doAfterClick();
        }
    }, [map, lote.geom, doAfterClick]);

    return (
        <OverlayTrigger placement="top" overlay={<Tooltip>LOCALIZAR</Tooltip>}>
            <button type="button" onClick={drawPropertyGeom}>
                <BsFillPinMapFill color="teal" size={iconsSize} />
            </button>
        </OverlayTrigger>
    );
};
